<!-- to use tabs: only title and value are required, the rest are optional
tabs: [
{
  title: translateText("priceApproval.awaitApproval"),
  value: "Awaiting",
  count: 0,
  icon:"random.svg",
  activeIcon:"activeRandom.svg"
  
},
{
  title: translateText("priceApproval.approvalHistory"),
  value: "Approved",
  count: 0,
},
],
<tabVue :tabs="tabs" @selectedTab="getTab" activeTab="awaiting" /> -->

<!-- to use table title: only table title is required
<tabVue tableTitle="random title" tableCount="0"/>  -->

<template>
  <section :class="containerClass">
    <div
      v-if="tabs"
      class="flex items-center border-b gap-x-4"
      :class="tabsContainerClass"
    >
      <div
        @click="selectTab(tab.value)"
        v-for="(tab, index) in tabs"
        :key="index"
        class="cursor-pointer"
        :class="tabContainerClass"
      >
        <div class="flex items-center justify-center gap-2 px-4 mb-2 capitalize">
          <img v-if="tab.icon" :src="getImage(tab)" />
          <p
            :class="[
              {
                'text-estationsGreen-500': selectedTab == tab.value,
                'text-gray-600': selectedTab !== tab.value,
              },
              'text-base font-medium',
              tabTextClass,
            ]"
          >
            {{ tab.title }}
          </p>
          <p
            v-if="tab.count != null"
            :class="{
              'bg-estationsGreen-100 text-estationsGreen-600':
                selectedTab == tab.value,
              'text-gray-700 bg-gray-100': selectedTab !== tab.value,
            }"
            class="w-[24px] h-[24px] flex items-center justify-center py-2 px-2 text-xs font-medium rounded-full"
          >
            {{ tab.count }}
          </p>
        </div>
        <div v-if="selectedTab == tab.value" class="activeTab"></div>
      </div>
    </div>

    <div v-if="tableTitle" class="flex items-center gap-2 p-3">
      <slot name="titleIcon"></slot>
      <h4 class="text-base font-medium text-gray-700">{{ tableTitle }}</h4>

      <div
        v-if="tableCount"
        class="inline-block p-1 px-2 text-xs font-medium text-gray-700 bg-gray-100 rounded-full"
      >
        {{ tableCount }}
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "TableTab",
  props: {
    tabs: { type: Array, required: false, default: null },
    activeTab: { type: String, required: false, default: "" },
    tableTitle: { type: String, default: null, required: false },
    tableCount: { type: Number, default: null, required: false },
    containerClass: { type: String, default: "", required: false },
    tabContainerClass: { type: String, default: "", required: false },
    tabsContainerClass: { type: String, default: "", required: false },
    tabTextClass: { type: String, default: "", required: false },
  },
  data() {
    return {
      selectedTab: this.activeTab,
    };
  },
  mounted() {
    if (this.activeTab && this.tabs?.length > 0) {
      this.selectedTab = this.tabs[0]?.value;
    }
  },
  methods: {
    selectTab(tab) {
      this.selectedTab = tab;
      this.$emit("selectedTab", tab);
    },
    getImage(tab) {
      let selectedIcon;
      if (tab.value == this.selectedTab) {
        selectedIcon = tab.activeIcon;
      }
      if (tab.value !== this.selectedTab) {
        selectedIcon = tab.icon;
      }
      return new URL(`../../../assets/svg/${selectedIcon}`, import.meta.url)
        .href;
    },
  },
};
</script>

<style>
.activeTab {
  /* width: 100%; */
  height: 2px;
  background: #1d8230;
  border-radius: 8px;
}
</style>
